/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_ANALYTICS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.analyticsPage.getAnalytics',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_ANALYTICS' },
      },
    },
    GET_ANALYTICS: {
      invoke: {
        id: 'getAnalytics',
        src: 'getAnalytics',
        onDone: {
          target: 'RENDER_ANALYTICS',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_ANALYTICS_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ANALYTICS: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_ANALYTICS',
        },
      },
    },
    RENDER_ANALYTICS_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
